export default {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    FIREBASE_KEY: process.env.REACT_APP_FIREBASE_API_KEY
}